var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"text-primary",class:{ 'v-icon-ride': _vm.leg.traverseMode === 'RIDESHARE' }},[_vm._v(" "+_vm._s(_vm.getIcon)+" ")]),_c('div',{staticClass:"travel-line",class:{
      dotted: _vm.leg.traverseMode === 'WALK',
    }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }